const context = require.context('./', true, /\.js$/);
const hash = {}
context.keys().map((path) => {
    if (['./index.js', './parent.js'].includes(path)) {
        return 
    }
    const contextObj = context(path)
    Object.keys(contextObj).forEach(key => {
        const obj = contextObj[key]
        hash[obj.f_name] = obj
    })
    
})  

export default hash